// code copied from https://git.hubteam.com/HubSpot/hubspot-tinymce/blob/master/tinymce-plugins/static/js/hsmedia/util.js

import enviro from 'enviro';
// [content-embed-ui] is deployed at `preview.hubspoteditor(qa).com`
export const getContentEmbedUIOrigin = () => {
  const qa = enviro.isProd() ? '' : 'qa';
  return `https://preview.hubspoteditor${qa}.com`;

  // Uncomment this if you want to run [content-embed-ui] locally since
  // benderproxy hosts all local apps on `local.hubspot(qa).com`. Be careful
  // when running [content-embed-ui] locally as the EmbedIframe has `sandbox`
  // of "allow-scripts allow-same-origin" which exposes possible XSS attacks.
  // return `https://local.hubspot${qa}.com`;
};
export const CONTENT_EMBED_UI_BASE_URL = `${getContentEmbedUIOrigin()}/content-embed-ui`;

// These actions must match those in
// https://git.hubteam.com/HubSpot/content-embed-ui/static/js/utils/constants.js
const actionPrefix = 'ContentEmbedUI';
export const ContentEmbedUIEvents = Object.freeze({
  READY: `${actionPrefix}:Ready`,
  SIZE_CHANGE: `${actionPrefix}:SizeChange`,
  SET_CONTENT: `${actionPrefix}:SetContent`,
  SET_CONTENT_DONE: `${actionPrefix}:SetContentDone`,
  DISCONNECT: `${actionPrefix}:Disconnect`
});

// Represents standard 16:9 aspect ratio
export const DefaultIframeDimensions = Object.freeze({
  WIDTH: 560,
  HEIGHT: 315
});
export const oEmbedProviders = Object.freeze({
  FACEBOOK: 'facebook',
  GIPHY: 'giphy',
  GOOGLE_CALENDAR: 'google-calendar',
  GOOGLE_DOCS: 'google-docs',
  GOOGLE_DRIVE_FOLDER: 'google-drive-folder',
  GOOGLE_MAPS: 'google-maps',
  GOOGLE_SHEETS: 'google-sheets',
  GOOGLE_SLIDES: 'google-slides',
  INSTAGRAM: 'instagram',
  PINTEREST: 'pinterest',
  SLIDESHARE: 'slideshare',
  TWENTYTHREE: 'twentythree',
  TWITTER: 'twitter',
  VIDYARD: 'vidyard',
  VIMEO: 'vimeo',
  WISTIA: 'wistia',
  YOUTUBE: 'youtube'
});
export const PixelRegex = /^[0-9]+$/;
// these are regex patterns for determining service types via embed codes, not URL's.
// use `urlPatterns` to define URL formats, which automatically create a service identifier
export const embedServiceTypes = [{
  type: oEmbedProviders.YOUTUBE,
  pattern: /https:\/\/(?:www\.)?youtube\.com\/embed/
}, {
  type: oEmbedProviders.TWITTER,
  pattern: /https:\/\/(?:www\.)?twitter\.com\/.+\//
}, {
  type: oEmbedProviders.FACEBOOK,
  pattern: /https:\/\/(?:www\.)?facebook\.com\/.+\//
}, {
  type: oEmbedProviders.INSTAGRAM,
  pattern: /https:\/\/(?:www\.)?instagram\.com\/.+\//
}, {
  type: oEmbedProviders.PINTEREST,
  pattern: /https:\/\/(?:www\.)?pinterest\.com\/.+\//
}, {
  type: oEmbedProviders.GOOGLE_MAPS,
  pattern: /https:\/\/(?:www\.)?google\.com\/maps\/embed/
}, {
  type: oEmbedProviders.GOOGLE_CALENDAR,
  pattern: /https:\/\/(?:www\.)?calendar\.google\.com\/calendar\/embed/
}, {
  type: oEmbedProviders.GOOGLE_DOCS,
  pattern: /https:\/\/(?:www\.)?docs\.google\.com\/.+\/document/
}, {
  type: oEmbedProviders.GOOGLE_SHEETS,
  pattern: /https:\/\/(?:www\.)?docs\.google\.com\/.+\/spreadsheets/
}, {
  type: oEmbedProviders.GOOGLE_SLIDES,
  pattern: /https:\/\/(?:www\.)?docs\.google\.com\/.+\/presentation/
}, {
  type: oEmbedProviders.GOOGLE_DRIVE_FOLDER,
  pattern: /https:\/\/(?:www\.)?drive\.google\.com\/embeddedfolder/
}, {
  type: oEmbedProviders.SLIDESHARE,
  pattern: /https:\/\/(?:www\.)?slideshare\.net\/slideshow\/embed_code/
}, {
  type: oEmbedProviders.TWENTYTHREE,
  pattern: /https:\/\/(?:www\.)?(\S+)\/((?:\d+|v)\.ihtml\/player\.html)/
}, {
  type: oEmbedProviders.GIPHY,
  pattern: /https:\/\/(?:www\.)?giphy\.com\/embed/
}, {
  type: oEmbedProviders.WISTIA,
  pattern: /(?:https:)?\/\/(?:www\.)?fast\.wistia\.net\/embed\/iframe/
}, {
  type: oEmbedProviders.VIMEO,
  pattern: /https:\/\/(?:www\.)?player\.vimeo\.com\/video/
}];
export const genericEmbedDomainPattern = [/<iframe\s+.*src="(?:http:|https:)?\/\/(?:www\.)?([a-zA-Z,0-9]+(?:.[a-zA-Z,0-9]+)?)\..*".*>/, /<script\s+.*src="(?:http:|https:)?\/\/(?:www\.)?([a-zA-Z,0-9]+(?:.[a-zA-Z,0-9]+)?)\..*".*>/];